import { ProgressChartCard, ProgressChartCardProps, ProgressCharts } from '../ProgressChartCard';

type FlatChartCardProps = Omit<ProgressChartCardProps, 'charts'> & {
    charts: Omit<ProgressCharts, 'cornerRadius' | 'total'>[];
};

export const FlatChartCard = (props: FlatChartCardProps) => {
    const charts = props.charts.map((chart) => ({
        ...chart,
        cornerRadius: false,
        total: chart.data.reduce((acc, item) => acc + item.value, 0),
    }));

    return <ProgressChartCard {...props} charts={charts} />;
};
